import type { WorkOrderState } from "@szyos/contracts";

/**
 * Was an einem Auftrag gerade wirklich passiert. Belegt durch Läufe, nicht durch den Zustand allein:
 * Ein Auftrag in RUNNING arbeitet nur, wenn ein Lauf aktiv ist. Angehaltene oder wartende Aufträge
 * erscheinen nie als laufend.
 */
export type OrderActivity = "working" | "queued" | "held" | "idle";

/** Läufe, die ein Node gerade hält oder ausführt. */
export const ACTIVE_RUN_STATES: readonly string[] = ["LEASED", "RUNNING", "SUSPECT"];

/** Zustände, in denen szyOS selbst prüft (CI, Stand vor dem Mergen), auch ohne Agentenlauf. */
const SERVER_CHECKS: readonly WorkOrderState[] = ["VERIFYING", "STAGING"];
const CLOSED: readonly WorkOrderState[] = ["RELEASED", "CANCELLED", "FAILED"];

export interface ActivityFacts {
  state: WorkOrderState;
  heldAt: string | null;
  /** Aktive Läufe des Auftrags, Planvorschläge eingeschlossen. */
  activeRuns: number;
  /** Läufe, die auf einen freien Platz warten. */
  queuedRuns: number;
}

export function orderActivity(o: ActivityFacts): OrderActivity {
  if (CLOSED.includes(o.state)) return "idle";
  // Ein laufender Lauf endet auch nach dem Anhalten regulär; erst danach ruht der Auftrag.
  if (o.activeRuns > 0 || SERVER_CHECKS.includes(o.state)) return "working";
  if (o.heldAt) return "held";
  if (o.queuedRuns > 0) return "queued";
  return "idle";
}

/** Zählt aktive und wartende Läufe aus einer Liste von Laufzuständen. */
export function countRuns(states: readonly string[]): { activeRuns: number; queuedRuns: number } {
  return {
    activeRuns: states.filter((s) => ACTIVE_RUN_STATES.includes(s)).length,
    queuedRuns: states.filter((s) => s === "QUEUED").length,
  };
}
